module.exports = __webpack_public_path__ + "img/modelo-sushi.1017efa4.png";